import Vue from "vue";
import nucleus from "ps-nucleus";

export default function RegisterNucleusComponents() {
    const nucleusComponents = nucleus.components;
    for (var component in nucleusComponents)  {
        Vue.component(nucleusComponents[component].name, nucleusComponents[component]);
    }
}